import { useEffect } from "react";

const origin = "https://rbeaujon.com";
const setMeta = (selector, attributes) => {
  let element = document.head.querySelector(selector);
  if (!element) { element = document.createElement("meta"); document.head.appendChild(element); }
  Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
};
const setLink = (selector, attributes) => {
  let element = document.head.querySelector(selector);
  if (!element) { element = document.createElement("link"); document.head.appendChild(element); }
  Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
};

export default function Seo({ title, description, path, locale = "EN", robots = "index,follow,max-image-preview:large", schema, preloadImage }) {
  useEffect(() => {
    const url = `${origin}${path}`;
    const language = locale === "ET" ? "et" : locale.toLowerCase();
    document.title = title;
    document.documentElement.lang = language;
    setMeta('meta[name="description"]', { name: "description", content: description });
    setMeta('meta[name="robots"]', { name: "robots", content: robots });
    setMeta('meta[property="og:title"]', { property: "og:title", content: title });
    setMeta('meta[property="og:description"]', { property: "og:description", content: description });
    setMeta('meta[property="og:url"]', { property: "og:url", content: url });
    setMeta('meta[property="og:image"]', { property: "og:image", content: `${origin}/og-ricardo-beaujon.jpg` });
    setMeta('meta[property="og:image:width"]', { property: "og:image:width", content: "1200" });
    setMeta('meta[property="og:image:height"]', { property: "og:image:height", content: "630" });
    setMeta('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    setMeta('meta[name="twitter:title"]', { name: "twitter:title", content: title });
    setMeta('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    setMeta('meta[name="twitter:image"]', { name: "twitter:image", content: `${origin}/og-ricardo-beaujon.jpg` });
    setLink('link[rel="canonical"]', { rel: "canonical", href: url });
    document.head.querySelector("#page-preload")?.remove();
    if(preloadImage){const preload=document.createElement("link");preload.id="page-preload";preload.rel="preload";preload.as="image";preload.href=preloadImage;preload.setAttribute("fetchpriority","high");document.head.appendChild(preload)}
    ["en", "es", "et", "x-default"].forEach((lang) => document.head.querySelector(`link[rel="alternate"][hreflang="${lang}"]`)?.remove());
    const baseRoute = path.replace(/^\/(es|et)(?=\/)/, "") || "/";
    [["en",baseRoute],["es",`/es${baseRoute}`],["et",`/et${baseRoute}`],["x-default",baseRoute]].forEach(([lang,href])=>setLink(`link[rel="alternate"][hreflang="${lang}"]`,{rel:"alternate",hreflang:lang,href:`${origin}${href}`}));
    const oldSchema = document.head.querySelector("#route-schema");
    oldSchema?.remove();
    if (schema) {
      const script = document.createElement("script"); script.id = "route-schema"; script.type = "application/ld+json";
      script.textContent = JSON.stringify(schema); document.head.appendChild(script);
    }
  }, [title, description, path, locale, robots, schema, preloadImage]);
  return null;
}
